/* eslint-disable no-loop-func */
/* eslint-disable no-continue */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-param-reassign */
/* eslint-disable import/prefer-default-export */
/* eslint-disable import/extensions */
import { DateTime } from 'luxon';
import 'focus-visible/dist/focus-visible.min.js';
import * as globals from './globals';
import * as utils from './utils';

const datepicker = {
  _eventListeners: {
    change: null,
    focus: null,
    blur: null,
  },
};

const initializeDatepicker = (baseSvgUrlInputId = '#datepicker-base-svg-url', datepickersClassSelector = globals.COMPONENTS_SELECTOR, errorMessage = null, allowedDates = null) => {
  const datepickers = document.querySelectorAll(datepickersClassSelector);
  const baseSvgUrlElem = document.querySelector(baseSvgUrlInputId);
  const parentMap = new WeakMap();

  const datepickerObserverCallback = (mutations) => {
    for (const mutation of mutations) {
      if (mutation.type !== 'childList') {
        continue;
      }

      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE && node.classList.contains(globals.INPUT_ERROR_CLASS)) {
          const baseSvgUrl = baseSvgUrlElem?.value || '';
          utils.handleAddedErrorNode(node, baseSvgUrl, parentMap);
        }
      });

      mutation.removedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE && node.classList.contains(globals.INPUT_ERROR_CLASS)) {
          utils.handleRemovedErrorNode(node, parentMap);
        }
      });
    }
  };

  const labels = {
    selected: 'selected',
    openCalendar: '',
    calendar: 'calendar',
    invalidDateError: errorMessage || 'We could not find a matching date',
    minDateError: 'Please fill in a date after',
    maxDateError: 'Please fill in a date before',
    rangeOutOfBoundsError: 'Please enter a valid range of dates',
    disabledDateError: 'Please choose an available date',
    to: 'to',
    startDate: 'Start date',
    todayButton: 'Today',
  };

  datepickers.forEach((datepickerElement) => {
    datepickerElement.inclusiveDatesLabels = labels;

    datepickerElement.disableDate = (date) => {
      if (allowedDates !== null) {
        return !allowedDates.includes(DateTime.fromISO(date.toISOString()).toFormat('yyyy-MM-dd'));
      }

      return false;
    };

    // event executed after the component is completely loaded
    datepickerElement.addEventListener('componentReady', () => {
      const input = datepickerElement.querySelector(globals.INPUT_SELECTOR);
      input.setAttribute('autocomplete', 'off');
      const openCalendarBtn = datepickerElement.querySelector(globals.CALENDAR_BUTTON_SELECTOR);
      const calendarBtns = datepickerElement.querySelectorAll(globals.CALENDAR_FOOTER_BUTTONS_SELECTOR);
      if (!openCalendarBtn) return;

      // adds at-btn styling to calendar buttons
      for (const btn of calendarBtns) {
        btn.classList.add('at-btn');
        btn.classList.add('at-btn--secondary');
        const btnContent = btn.innerHTML.toLowerCase();
        if (btnContent.includes(labels.todayButton.toLowerCase())) {
          btn.innerHTML = labels.todayButton;
          btn.addEventListener('click', () => {
            setTimeout(() => {
              const focusedElement = document.activeElement;
              if (focusedElement) {
                focusedElement.click();
              }
            }, 10);
          });
        }
      }

      // adds necessity indicator if needed
      if (datepickerElement.hasAttribute('necessity')) {
        const label = datepickerElement.querySelector('label');
        const span = document.createElement('span');
        span.classList.add('inclusive-dates__label--necessity');
        span.innerText = ` ${datepickerElement.getAttribute('necessity')}`;
        label.appendChild(span);
      }

      const baseSvgUrl = baseSvgUrlElem?.value || '';

      const calendarIconElement = document.createElementNS(globals.NAMESPACE_SVG_URI, 'svg');
      const useElement = document.createElementNS(globals.NAMESPACE_SVG_URI, 'use');

      calendarIconElement.classList.add(globals.CALENDAR_ICON_CLASS);
      useElement.setAttribute('href', `${baseSvgUrl}#icon-calendar`);

      calendarIconElement.appendChild(useElement);
      openCalendarBtn.appendChild(calendarIconElement);

      const datepickerObserver = new MutationObserver(datepickerObserverCallback);

      datepickerObserver.observe(datepickerElement, { childList: true, subtree: true });

      // Attach an event listener to update the input field value when the user changes it.
      // Ensure that we aren't transforming by mistake dates e.g. (01/05/2025 -> 05/01/2025) when the users uses enter key or inputs a valid date in format (DD/MM/YY)
      input.addEventListener('change', (e) => {
        if (!e.target.value) {
          return true;
        }

        const formattedDate = utils.convertDateToISOFormat(e.target.value);
        e.target.value = formattedDate;

        return true;
      }, true);
    });

    // event executed everytime a date is selected by the user
    datepickerElement.addEventListener('selectDate', (event) => {
      const formattedDate = utils.formatDate(new Date(event.detail));
      const formattedDateInputElement = event.currentTarget.querySelector(globals.INPUT_SELECTOR);

      if (formattedDateInputElement.value === formattedDate) {
        return;
      }

      formattedDateInputElement.value = formattedDate;

      Object.entries(datepicker._eventListeners).forEach(([eventType, listener]) => {
        const isChangeEvent = eventType === 'change';
        const targetElement = isChangeEvent ? datepickerElement : formattedDateInputElement;

        // remove existing event listener
        if (listener) {
          targetElement.removeEventListener(eventType, listener);
        }

        // Add new event listener
        const newListener = utils.handleChangeEvent(formattedDateInputElement, formattedDate);
        datepicker._eventListeners[eventType] = newListener;
        targetElement.addEventListener(eventType, newListener);
      });
    });
  });
};

export { initializeDatepicker };